<template>
    <IQOS required :title="$t('online_payment.menu_panel.title')">
        <p class="iqos-comment qrw-paragraph-md mt-16">
           {{ $t('online_payment.menu_panel.comment')}}
        </p>

        <BaseCheckbox 
            class="mt-16"
            v-for="(menu,index) in menus" 
            :key="menu._id" 
            :value="menu.pay_receiver_id == merchant._id"
            @input="v => onMenuToggled(index, v)">
            {{ menu.title }}
        </BaseCheckbox>
    </IQOS>
</template>

<script>
import MenuAPI from "@/api/menu"

export default {
    props: {
        merchant: Object
    },
    data() {
        return {
            
        }
    },
    methods: {
        onMenuToggled(index, v) {
            const menu = this.menus[index];
            const value = v ? this.merchant._id : null;
            MenuAPI.updatePayReceiverId(menu._id, value).then(data => {
                this.$set(this.menus[index], 'pay_receiver_id', value);

                this.$store.commit('setPaymentMenusBuffer', this.menus);
            }).catch(err => {
                console.error(err);
            })
        }
    },
    computed: {
        menus() {
            return this.$store.state.payment_menus_buffer;
        }
    },
    mounted() {
       
    },
}
</script>

<style>

</style>